/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { KeyboardEvent, PropsWithChildren, useMemo } from 'react';
import { KeyEvent } from '../../../../types/KeyEvent';

type PALPanelProps = PropsWithChildren<{
  id: string;
  labelledby: string;
  isActivePanel: boolean;
  panelAreaExpanded: boolean;
  focusTab: () => void;
}>;

export function PALPanel({ id, labelledby, isActivePanel, panelAreaExpanded, focusTab, children }: PALPanelProps) {
  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.code === KeyEvent.Escape) {
      event.stopPropagation();
      focusTab();
    }
  };

  return useMemo(
    () => (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <div
        className="pal-panel__container"
        id={id}
        role="tabpanel"
        aria-labelledby={labelledby}
        aria-hidden={!isActivePanel || !panelAreaExpanded}
        // we need tabindex here according to accessibility rules
        // https://w3.org/TR/wai-aria-practices/examples/tabs/tabs-2/tabs.html
        tabIndex={isActivePanel && panelAreaExpanded ? 0 : -1}
        // we need onKeyUp here in order to improve accessibility: an ESC hit
        // shall not close the whole PAL, but only jump back to a panels'
        // corresponding tab
        onKeyDown={onKeyDown}
      >
        {/* only render active panel, now possible as WS connections are kept in PAL */}
        {isActivePanel && children}
      </div>
    ),
    // only rerender if panelExpanded or activepanel props change
    // but maybe we dont need the areaExpanded prop anymore, needs to be checked
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [panelAreaExpanded, isActivePanel]
  );
}
